import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const cityPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.City },
    { actions: [Actions.read], subject: Models.Cities },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.City },
    { actions: [Actions.read], subject: Models.Cities },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read, Actions.create, Actions.delete, Actions.update], subject: Models.City },
    { actions: [Actions.read], subject: Models.Cities },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.City },
    { actions: [Actions.read], subject: Models.Cities },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
